import { lazy } from 'react';

const CharityVettingAcceptsAllNonFoodEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingAcceptsAllNonFood" */ '../components/steps/charity-accepts-all-non-food-step/CharityAcceptsAllNonFood'
    ),
);

export default CharityVettingAcceptsAllNonFoodEntry;
